import { useQuery } from '@tanstack/react-query';
import { iarService } from '@/services/iar/IARService';
import type { IARRunSummary } from '@/types/iar';

/**
 * Returns the single In Progress IAR run if one exists, or null.
 * Polled on the dashboard to show a "Resume IAR" banner.
 */
export const usePendingIARRun = () => {
  return useQuery({
    queryKey: ['pending-iar-run'],
    queryFn: async (): Promise<IARRunSummary | null> => {
      const runs = await iarService.listRuns();
      return runs.find((r) => r.status === 'In Progress') ?? null;
    },
    staleTime: 60 * 1000,
  });
};
